import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemDismiss from "components/BulkActions/Drawer/Item/Dismiss";
import { ActionAvailabilityBanner } from "components/BulkActions/Drawer/Item/ActionAvailabiltyBanner";
import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsActionDescriptor,
  BulkActionsStep,
} from "components/BulkActions/types";
import SpacePath from "components/SpacePath";
import Box from "ds/components/Box";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageIntegration } from "hooks/useAnalytics/pages/integrations";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

import { AiIntegrationsBulkActions } from "./types";

type AiIntegrationsBulkActionsSelectedItemPropsBase = {
  item: AiIntegrationView;
  onDismiss: (id: BulkActionItemID) => void;
};

type AiIntegrationsBulkActionsSelectedItemProps = AiIntegrationsBulkActionsSelectedItemPropsBase &
  (
    | {
        step: BulkActionsStep.ActionConfirmation;
        itemCategory: BulkActionActionConfirmationTabs;
        itemActions?: never;
        allActionsQty?: never;
      }
    | {
        step: BulkActionsStep.ChooseAction;
        itemActions: BulkActionsActionDescriptor<AiIntegrationsBulkActions>[] | undefined;
        allActionsQty: number;
        itemCategory?: never;
      }
  );

const AiIntegrationsBulkActionsSelectedItem = ({
  item,
  itemActions,
  onDismiss,
  allActionsQty,
  step,
}: AiIntegrationsBulkActionsSelectedItemProps) => {
  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageIntegration.IntegrationsList,
  });

  const handleDismiss = () => {
    onDismiss(item.id);
    trackSegmentAnalyticsEvent("Bulk Actions - Drawer - Item dismissed");
  };

  const isChooseActionStep = step === BulkActionsStep.ChooseAction;
  const actionTexts = (itemActions || []).map((action) => action.title);

  return (
    <BulkActionsDrawerItem key={item.id} direction="column" align="start">
      <Box gap="medium" align="start" justify="between" fullWidth>
        <Box gap="large" direction="column" grow="1" zeroMinWidth>
          <TextEllipsis tooltip={item.name} tooltipWidthMode="maxWidthSm">
            {(props) => (
              <Typography {...props} tag="p" variant="p-body3">
                {item.name}
              </Typography>
            )}
          </TextEllipsis>

          <Box align="center" gap="medium" zeroMinWidth fullWidth>
            <Typography tag="span" variant="p-body4" color="secondary">
              {item.provider}
            </Typography>

            {item.space && (
              <Box zeroMinWidth grow="1">
                <SpacePath spaceId={item.space.id} fallbackName={item.space.name} />
              </Box>
            )}
          </Box>
        </Box>

        <BulkActionsDrawerItemDismiss onDismiss={handleDismiss} />
      </Box>

      {isChooseActionStep && (
        <ActionAvailabilityBanner itemActions={actionTexts} allActionsQty={allActionsQty} />
      )}
    </BulkActionsDrawerItem>
  );
};

export default AiIntegrationsBulkActionsSelectedItem;
